/**
 * Beyond AI brand tokens — single source of truth.
 * Import from here whenever you render an AI surface.
 */

export const BEYOND_AI_LOGO = "https://customer-assets.emergentagent.com/job_a2ffd257-50b9-4530-8932-b0e03417ee6f/artifacts/9v3936lg_Beyond%20AI.png";

export const BEYOND_AI = {
  blue:     '#1F6FE5',
  teal:     '#2DD4BF',
  gradient: 'linear-gradient(135deg, #1F6FE5 0%, #2DD4BF 100%)',
  bg:       '#E8F3FF',
  border:   '#BFD8F5',
};

/**
 * Inline "Beyond AI" wordmark — "AI" rendered in brand teal.
 */
export function BeyondAIWordmark({ className = '' }) {
  return (
    <span className={className}>
      Beyond <span style={{ color: BEYOND_AI.teal, fontWeight: 700 }}>AI</span>
    </span>
  );
}

/**
 * Small square logo with rounded corners — use wherever Bot/Sparkles was used.
 * size prop maps to Tailwind w/h classes e.g. "8" → w-8 h-8
 */
export function BeyondAIIcon({ size = 8, className = '' }) {
  return (
    <img
      src={BEYOND_AI_LOGO}
      alt="Beyond AI"
      className={`rounded-xl object-cover w-${size} h-${size} shrink-0 ${className}`}
    />
  );
}

/**
 * Small pill badge — "Beyond AI"
 */
export function BeyondAIBadge({ label = 'Beyond AI', className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold text-white ${className}`}
      style={{ background: BEYOND_AI.gradient }}
    >
      <img src={BEYOND_AI_LOGO} alt="" className="w-3 h-3 rounded-sm object-cover" />
      {label}
    </span>
  );
}
